import { APICore } from './apiCore'

const api = new APICore()

function getImages (owner) {
  const baseUrl = `/images/${owner}`
  return api.get(baseUrl, {})
}
export { getImages }
